require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _colors = require("../../styles/colors");

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Appbar/AppbarAction.tsx";

var AppbarAction = function (_React$Component) {
  (0, _inherits2["default"])(AppbarAction, _React$Component);

  function AppbarAction() {
    (0, _classCallCheck2["default"])(this, AppbarAction);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AppbarAction).apply(this, arguments));
  }

  (0, _createClass2["default"])(AppbarAction, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$color = _this$props.color,
          iconColor = _this$props$color === void 0 ? (0, _color["default"])(_colors.black).alpha(0.54).rgb().string() : _this$props$color,
          icon = _this$props.icon,
          disabled = _this$props.disabled,
          onPress = _this$props.onPress,
          accessibilityLabel = _this$props.accessibilityLabel,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["color", "icon", "disabled", "onPress", "accessibilityLabel"]);
      return React.createElement(_IconButton["default"], (0, _extends2["default"])({
        onPress: onPress,
        color: iconColor,
        icon: icon,
        disabled: disabled,
        accessibilityLabel: accessibilityLabel,
        animated: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        }
      }));
    }
  }]);
  return AppbarAction;
}(React.Component);

exports["default"] = AppbarAction;
(0, _defineProperty2["default"])(AppbarAction, "displayName", 'Appbar.Action');
(0, _defineProperty2["default"])(AppbarAction, "defaultProps", {
  size: 24
});